import axios, { AxiosInstance } from 'axios';
import { keycloak } from '../security/keycloak';
import { translation } from '../i18n';

/**
 * @returns {Promise<AxiosInstance>} that resolves to a axios instance that sets the appropriate Authentication headers.
 * Refreshes the access token when necessary.
 */
export function myAxios(): Promise<AxiosInstance> {
  const instance = axios.create();
  return keycloak.updateToken(5).then(() => {
    instance.defaults.headers.common.Authorization = `Bearer ${keycloak.token}`;
    instance.defaults.headers.common.Accept = `application/json`;
    return instance;
  }).catch(() => {
    window.alert(translation.t('errors.session_expired'));
    keycloak.clearToken();
    throw new Error('Session expired');
  });
}
